import { createFileRoute } from "@tanstack/react-router";
import { ConnectionNew } from "../../../features/connections/connection-new";
import { isConnectionType, type ConnectionType } from "../../../features/connections/model";

export const Route = createFileRoute("/_authed/$org/$project/connections/new")({
  validateSearch: (s: Record<string, unknown>): { type?: ConnectionType } => (isConnectionType(s.type) ? { type: s.type } : {}),
  component: NewConnectionPage,
});

function NewConnectionPage() {
  const { org, project } = Route.useParams();
  const { type } = Route.useSearch();
  return <ConnectionNew scope={{ org, project }} {...(type ? { type } : {})} />;
}
